export interface FlowVariable {
  behavior: string;
  name: string;
  value: string;
  instruction:string;
}
export enum FlowVariableBehavior {
  SET = "SET",
  SET_FOR_EACH = "SET_FOR_EACH",
  APPEND = "APPEND",
  APPEND_FOR_EACH = "APPEND_FOR_EACH"
}